module.exports = __webpack_public_path__ + "static/media/gauge_blue.e2add721.png";